// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__FCnYt","rightAdornment":"Header_rightAdornment__3QjP0"};